import { ReactNode, useState } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';
import { mix } from 'polished';

import { Card, Popover } from '@treams/treams-ui';

const OverviewItemHeaderContainer = styled(Flex)<{ $color: string; $jumbo?: boolean }>`
	align-items: center;
	justify-content: center;
	background: ${(props) => mix(0.75, 'white', props.theme.colors[props.$color])};
	border: 1px solid ${(props) => mix(0.5, 'white', props.theme.colors[props.$color])};
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
	height: 112px;

	${(props) =>
		props.$jumbo &&
		`
        border-radius: 5px;
        height: 200px;
    `}

	svg {
		display: block;
		width: 48px;
		height: 48px;

		path {
			fill: ${(props) => props.theme.colors[props.$color]};
		}
	}
`;

function OverviewItemHeader(props: { color: string; icon: ReactNode }) {
	return (
		<OverviewItemHeaderContainer $color={props.color}>{props.icon}</OverviewItemHeaderContainer>
	);
}

export default function OverviewItem(props: {
	color: string;
	icon: ReactNode;
	title: string;
	link: string;
	enabled?: boolean;
	upsell?: ReactNode;
}) {
	const [visible, setVisible] = useState(false);

	return (
		<Popover.Target
			center
			visible={visible}
			contents={props.upsell}
			onDismiss={() => setVisible(false)}
		>
			<Card
				onClick={props.enabled === false && props.upsell ? () => setVisible(true) : undefined}
				header={
					<OverviewItemHeader
						color={props.enabled === false ? 'slateBlue' : props.color}
						icon={props.icon}
					/>
				}
				link={props.enabled !== false ? props.link : undefined}
			>
				<Box lineHeight="24px">{props.title}</Box>
			</Card>
		</Popover.Target>
	);
}
